<template>
  <v-card>
    <div v-if="!titulo">
      <v-card-title class="display-1">
        Habilidades e Competências
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          label="Busca"
          single-line
          hide-details
          v-model="search"
        ></v-text-field>
      </v-card-title>
    </div>
    <div v-if="titulo">
      <v-card-title >
        <h2> Selecione uma Habilidades e Competências para avaliação</h2>
        <v-spacer></v-spacer>
        <v-text-field
          append-icon="search"
          label="Busca"
          single-line
          hide-details
          v-model="search"
        ></v-text-field>
      </v-card-title>
    </div>
      <v-card-text style="text-align: center;" align-content-center>

    <v-data-table
        :headers="headers"
        :items="criterios"
        :search="search"
        v-model="selected"
        :rows-per-page-items='[20,40,100,{"text":"Todos","value":-1}]'
        item-key="id"
        select-all
        class="elevation-1"
    >
        <template slot="headerCell" slot-scope="props">
        <v-tooltip bottom>
            <span slot="activator">
            {{ props.header.text }}
            </span>
            <span>
            {{ props.header.text }}
            </span>
        </v-tooltip>
        </template>
        <template slot="items" slot-scope="props">
        <td>
            <v-checkbox
            primary
            hide-details
            v-model="props.selected"
            ></v-checkbox>
        </td>
        <td class="text-xs-right">{{ props.item.classificacao }}</td>
        <td class="text-xs-right">{{ props.item.grupo }}</td>
        <td class="text-xs-right">{{ props.item.subgrupo }}</td>
        <td class="text-xs-right">{{ props.item.name }}</td>
        </template>
    </v-data-table>



    </v-card-text>
    <v-card-actions>
    <v-spacer />
    <v-btn color="error" flat @click.stop="cancel">Cancelar</v-btn>
    <v-btn color="primary" v-if="!btnedit" flat @click.stop="saved">Salvar</v-btn>
    <v-btn color="primary" v-if="btnedit" flat @click.stop="edit">OK</v-btn>
    </v-card-actions>

    <v-snackbar
    v-model="snackbar"
    left
    color="warning">
    {{ text }}
      <v-btn flat color="black" @click.native="snackbar = false">Close</v-btn>
    </v-snackbar>
  </v-card>
</template>

<script>

export default {
  props: [
    'criterios',
    'titulo',
    'clear',
    'btnedit',
    'editavel',
    'editHabil',
    'solicitacao'
  ],
  data () {
    return {
      search: '',
      selected: [],
      snackbar: false,
      text: '',
      headers: [
        {text: 'Classificação', value: 'classificacao'},
        {text: 'Grupo', value: 'grupo'},
        {text: 'Subgrupo', value: 'subgrupo'},
        {text: 'Habilidade ou Competência', value: 'name'}
      ]

    }
  },
  methods: {
    saved () {
      console.log('tamanho', this.selected.length)
      if (this.solicitacao) {
        if (this.selected.length === 0) {
          this.text = 'Selecione 1 habilidade'
          this.snackbar = true
        } else {
          if (this.selected.length > 1) {
            this.text = 'Selecione apenas 1 habilidade'
            this.snackbar = true
          } else {
            this.$emit('saved', this.selected)
            this.$emit('scrool')
            this.selected = []
          }
        }
      } else {
        this.$emit('saved', this.selected)
        this.$emit('scrool')
        this.selected = []
      }
    },
    edit () {
      if (this.solicitacao) {
        if (this.selected.length === 0) {
          this.text = 'Selecione 1 habilidade'
          this.snackbar = true
        } else {
          if (this.selected.length > 1) {
            this.text = 'Selecione apenas 1 habilidade'
            this.snackbar = true
          }
        }
      } else {
        this.$emit('edit', this.selected, this.ident)
        this.selected = []
      }
    },
    cancel () {
      this.$emit('cancel')
    }
  },
  mounted () {
    this.$watch('editavel', function () {
      this.selected = this.editavel.habilidades_pks
    })
    this.$watch('editHabil', function () {
      this.selected = this.editHabil.habilidades
    })
  }

}
</script>



// WEBPACK FOOTER //
// src/components/reusable/inputCriteriosAval.vue